/**
 * `<SettingsCard>` — the Final (Attio) settings section: a flat
 * `rounded-xl border bg-card` card with an icon + title header and an
 * optional right-aligned action. Used by the workspace / members / roles
 * settings surfaces. Mirrors the Storybook `final/_settings` SettingsCard.
 */

import { type LucideIcon } from "./icons";
import type { ReactNode } from "react";

export function SettingsCard({
  icon: Icon,
  title,
  action,
  children,
  ...rest
}: {
  icon: LucideIcon;
  title: string;
  action?: ReactNode;
  children?: ReactNode;
  "data-testid"?: string;
}) {
  return (
    <section className="rounded-xl border border-border bg-card" data-testid={rest["data-testid"]}>
      <div className="px-5 py-4">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5">
            <Icon className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" />
            <h3 className="text-sm font-semibold tracking-[0.01em] text-foreground">{title}</h3>
          </div>
          {action}
        </div>
        {children ? <div className="mt-4">{children}</div> : null}
      </div>
    </section>
  );
}
